import React from 'react';
import { 
  AlertTriangle, ShieldCheck, Target, Users, Sparkles, 
  Zap, Activity, Shield, ShieldAlert, HeartPulse, Compass, 
  Download, Loader2, Brain, BarChart3, List 
} from 'lucide-react';

import EditableAIBox from '../EditableAIBox';

// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const PsikolojikSaglamlikReportUI = ({ data, meta }) => {
  const totalScore = data.totalScore || 0;
  const risks = data.risks || [];

  // Puan Bazlı Tipoloji (Klinik Çerçeve)
  let typology = { title: "Dengeli (Normal) Profil", desc: "Öğrencinin stresli olaylar karşısında toparlanma becerisi ortalama düzeydedir. Gelişime açıktır.", color: "text-blue-800", bg: "bg-blue-50", border: "border-blue-200", iconCol: "text-blue-600", icon: Shield };
  
  if (totalScore < 18) {
      typology = { title: "Kırılgan Profil (Yüksek Risk)", desc: "Öğrenci krizler ve aksilikler karşısında toparlanmakta ciddi güçlük çekmektedir. Stres toleransı çok düşüktür ve psikolojik desteğe ihtiyaç duymaktadır.", color: "text-rose-800", bg: "bg-rose-50", border: "border-rose-200", iconCol: "text-rose-600", icon: ShieldAlert };
  } else if (totalScore >= 25) {
      typology = { title: "Dirençli Profil (Yüksek Yılmazlık)", desc: "Öğrencinin psikolojik sağlamlık kapasitesi çok yüksektir. Kriz anlarında hızlıca toparlanabilir ve stresle başa çıkma mekanizmaları çok güçlüdür.", color: "text-emerald-800", bg: "bg-emerald-50", border: "border-emerald-200", iconCol: "text-emerald-600", icon: ShieldCheck };
  }

  // İlk 24 Saat Müdahalesi (Micro-Actions)
  const getMicroAction = () => {
      if (totalScore < 18) return "Öğrenciyi gördüğünüzde 'Neden mutsuzsun?' yerine, güvende olduğunu hissettiren baskısız bir diyalog kurun. Küçük başarılarını anında takdir ederek 'hata yapma lüksü' olduğunu hissettirin.";
      if (totalScore >= 25) return "Liderlik ve akran desteği gerektiren küçük sorumluluklar vererek onun bu güçlü toparlanma becerisini sınıf içinde bir modele dönüştürün.";
      return "Zorlandığı anlarda duygularını ifade etmesi için alan açın ve 'Bunu aşabileceğini biliyorum' diyerek gizli potansiyelini hatırlatın.";
  };

  const isRedAlarm = totalScore < 18;
  const isHighVolume = risks.length > 3;

  return (
    <div className="space-y-6 print:space-y-4 font-sans flex flex-col print:min-h-[260mm]">
      
      {/* BAŞLIK VE KİMLİK KARTI */}
      <div className={`p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'}`}>
        <div className="flex items-center gap-4 print:gap-3">
          <div className={`h-12 w-12 print:h-9 print:w-9 rounded-xl flex items-center justify-center shadow-inner ${isRedAlarm ? 'bg-red-600' : 'bg-slate-700'}`}>
            {isRedAlarm ? <AlertTriangle className="h-6 w-6 print:h-4 print:w-4"/> : <Shield className="h-6 w-6 print:h-4 print:w-4"/>}
          </div>
          <div>
            <h2 className="text-xl print:text-lg font-bold leading-none mb-1">Psikolojik Sağlamlık (Resilience) Analizi</h2>
            <span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
               {meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}
            </span>
          </div>
        </div>
        <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300">
          <span className={`text-2xl print:text-xl font-black block leading-none ${isRedAlarm ? 'text-red-300' : 'text-slate-200'}`}>{totalScore}</span>
          <span className="text-[9px] print:text-[9px] block opacity-70 uppercase font-bold mt-0.5">Skor (Maks 30)</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4">
         
         <div className={`${typology.bg} p-5 print:p-4 rounded-2xl border ${typology.border} print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm relative overflow-hidden`}>
           <div className={`flex items-center mb-3 print:mb-2 border-b ${typology.border} pb-2 print:pb-1.5 opacity-90 print:border-slate-200`}>
             <typology.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${typology.iconCol}`}/>
             <span className={`text-xs print:text-[10.5px] font-black uppercase tracking-widest ${typology.color}`}>Dayanıklılık Tipolojisi</span>
           </div>
           
           <h3 className={`text-lg print:text-[13px] font-black mb-1.5 print:mb-1 mt-1 leading-tight ${typology.color}`}>
             {typology.title}
           </h3>
           <p className="text-[11px] print:text-[10px] text-slate-700 leading-snug font-medium mb-3 print:mb-2 text-justify">
             {typology.desc}
           </p>

           {isRedAlarm && (
             <div className="mt-auto bg-red-100/80 border border-red-200 p-2 print:p-1.5 rounded-lg flex items-center shadow-sm">
               <AlertTriangle className="h-4 w-4 print:h-3 print:w-3 text-red-600 mr-2 animate-pulse"/>
               <span className="text-[10px] print:text-[8px] font-bold text-red-800 leading-tight uppercase tracking-wide">Acil: Kriz anlarında kırılma riski yüksek!</span>
             </div>
           )}
         </div>

         <div className="bg-sky-50 p-5 print:p-4 rounded-2xl border border-sky-100 shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300">
           <div className="flex items-center mb-1">
             <Zap className="h-5 w-5 print:h-4 print:w-4 text-sky-600 mr-2"/>
             <span className="text-xs print:text-[10px] font-black uppercase tracking-widest text-sky-900">PDR İlk Temas Stratejisi</span>
           </div>
           <h4 className="text-sm print:text-[11.5px] font-black text-sky-800 mb-1.5 mt-1">(İlk 24 Saat Müdahalesi)</h4>
           <p className="text-[13px] print:text-[9.5px] font-medium text-sky-900 leading-snug text-justify">
             {getMicroAction()}
           </p>
         </div>

      </div>

      {/* RİSKLİ MADDELER LİSTESİ */}
      <div className="bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 print:bg-white print:border-t-2 print:border-slate-900 print:rounded-none print:shadow-none flex-1 mt-2">
        <h3 className="font-bold text-slate-800 mb-4 print:mb-3 flex items-center text-sm print:text-[11px] border-b pb-3 print:pb-2">
          <List className="h-4 w-4 mr-2 text-slate-500"/> Zorlanılan / Kırılgan Olunan Alanlar ({risks.length})
        </h3>
        
        {risks.length > 0 ? (
          <div className={`grid grid-cols-1 md:grid-cols-2 ${isHighVolume ? 'print:grid-cols-3 print:gap-1.5' : 'print:grid-cols-2 print:gap-2.5'} gap-3`}>
            {risks.map((item, i) => (
              <div key={i} className={`flex items-start p-3 ${isHighVolume ? 'print:p-1.5' : 'print:p-2'} bg-white border border-red-200 bg-red-50/30 rounded-xl print:rounded-lg shadow-sm transition-colors`}>
                <div className={`min-w-[24px] h-6 ${isHighVolume ? 'print:min-w-[14px] print:h-3.5 print:text-[7px]' : 'print:min-w-[18px] print:h-4.5 print:text-[8px]'} rounded flex items-center justify-center text-[10px] font-black mr-3 ${isHighVolume ? 'print:mr-1.5' : 'print:mr-2'} border bg-red-100 text-red-700 border-red-200`}>
                  {item.id}
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-center mb-1 print:mb-[1px]">
                    <span className={`block text-[8px] ${isHighVolume ? 'print:text-[6.5px]' : 'print:text-[7.5px]'} font-bold text-slate-400 uppercase tracking-wider`}>Toparlanma Sorunu</span>
                    {item.isCritical && <span className={`text-[8px] ${isHighVolume ? 'print:text-[6px] px-1 py-[1px]' : 'print:text-[7px] px-1.5 py-0.5'} bg-red-100 text-red-700 rounded font-black tracking-widest uppercase shadow-sm`}>Kritik</span>}
                  </div>
                  <span className={`text-[11px] ${isHighVolume ? 'print:text-[8px] leading-tight' : 'print:text-[9.5px] leading-snug'} text-slate-800 font-medium block`}>{item.text}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-slate-400 italic text-center py-4 print:py-2">Öğrencinin toparlanmakta zorlandığı belirgin bir madde bulunmamaktadır.</p>
        )}
      </div>
    </div>
  );
};


// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregatePsikolojikSaglamlik = (subs) => {
  const total = subs.length;
  if (total === 0) return null;

  let redAlarmStudents = 0;
  let totalScoreSum = 0;
  const itemMap = {}; 
  const classMap = {};

  subs.forEach(s => {
    const className = s.studentClass || "Tüm Sınıflar";
    if (!classMap[className]) {
      classMap[className] = { name: className, studentCount: 0, scoreSum: 0, riskCount: 0 };
    }
    classMap[className].studentCount++;

    const score = s.reportData?.totalScore || 0;
    totalScoreSum += score;
    classMap[className].scoreSum += score;

    if (score < 18) {
        redAlarmStudents++;
        classMap[className].riskCount++;
    }

    const risks = s.reportData?.risks || [];
    risks.forEach(r => {
      const cleanText = r.text;
      const id = r.id;
      if (!itemMap[id]) itemMap[id] = { id, text: cleanText, count: 0 };
      itemMap[id].count++;
    });
  });

  const avgScore = total > 0 ? Math.round(totalScoreSum / total) : 0;
  
  const classStats = Object.values(classMap).map(c => ({
    ...c,
    avgScore: c.studentCount > 0 ? Math.round(c.scoreSum / c.studentCount) : 0
  })).sort((a, b) => a.avgScore - b.avgScore); // Puanı düşük olan (riskli) en üste gelir

  const topItems = Object.values(itemMap)
    .map(i => ({ ...i, percent: Math.round((i.count / total) * 100) }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 5); // En zorlanılan 5 madde

  return { total, redAlarmStudents, avgScore, classStats, topItems };
};


// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const PsikolojikSaglamlikBulkReportUI = ({ title, subs, aiResult, onGenerateAI, aiLoading, handlePrint, downloading }) => {
  const data = aggregatePsikolojikSaglamlik(subs);
  if (!data) return <div className="p-8 text-center text-slate-500">Bu gruba ait veri bulunamadı.</div>;

  const isRedAlarm = data.avgScore < 18 || data.redAlarmStudents > (data.total * 0.3);
  const redAlarmPercent = data.total > 0 ? Math.round((data.redAlarmStudents / data.total) * 100) : 0;

  // Dinamik Müdahale Objeleri
  const interventionObj = {
      title: "Okul İklimi ve Stres Yönetimi",
      icon: HeartPulse, color: "text-fuchsia-700", bg: "bg-fuchsia-50 print:bg-white border-fuchsia-200 print:border-slate-300",
      desc: "Öğrencilerin zorluklar karşısındaki kırılganlığını azaltmak için okul çapında dayanıklılık çalışmaları planlanmalıdır.",
      bullets: [
          "Okul PDR Servisi tarafından 'Stresle Başa Çıkma ve Yılmazlık' seminerleri düzenlenmelidir.",
          "Hata yapma korkusunu azaltacak, çabayı öven (gelişim odaklı zihniyet) bir okul dili inşa edilmelidir.",
          "Kırılganlık puanı yüksek (Kırmızı Alarm) gruplar için 4-6 haftalık psiko-eğitim grupları açılmalıdır."
      ]
  };

  const stakeholderObj = {
      title: "Öğretmen ve Veli Görevleri",
      icon: Users, color: "text-indigo-700", bg: "bg-indigo-50 print:bg-white border-indigo-200 print:border-slate-300",
      desc: "Öğrencinin toparlanma becerisi, çevresindeki yetişkinlerin tepkileriyle doğrudan şekillenir.",
      bullets: [
          "Öğretmenler: Sınav veya deneme sonralarında başarısızlıklara yıkıcı değil, onarıcı (Nasıl düzeltebiliriz?) yaklaşmalıdır.",
          "Veliler: Çocukların karşılaştığı her engeli onlar adına çözmek (helikopter ebeveynlik) yerine, onlara rehberlik etmelidir.",
          "İdare: Öğrencilerin sadece akademik değil, sosyal ve sanatsal başarılarının da kutlandığı alanlar yaratmalıdır."
      ]
  };

  return (
    <>
      <div className="flex justify-end mb-4 no-print px-2">
         <button onClick={() => handlePrint('saglamlik-kurumsal-area')} disabled={downloading} className="bg-blue-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-blue-700 transition">
            {downloading ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download className="h-5 w-5 mr-2"/>} Raporu Yazdır / PDF
         </button>
      </div>

      <div id="saglamlik-kurumsal-area" className="font-sans flex flex-col bg-white print:bg-white">
        
        {/* ========================================================= */}
        {/* SAYFA 1: DERGİ KAPAĞI - YÖNETİCİ ÖZETİ VİTRİNİ             */}
        {/* ========================================================= */}
        <div className="flex flex-col gap-5 print:gap-3 mb-6 print:mb-0">
          
          <div className={`p-5 print:p-3 rounded-2xl flex justify-between items-center shadow-sm print:shadow-none print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'} shrink-0 avoid-break`}>
            <div className="flex items-center gap-5 print:gap-3">
              <div className={`h-14 w-14 print:h-10 print:w-10 rounded-xl flex items-center justify-center shadow-inner ${isRedAlarm ? 'bg-red-600' : 'bg-slate-700'}`}>
                <Shield className="h-7 w-7 print:h-5 print:w-5"/>
              </div>
              <div>
                <h2 className="text-2xl print:text-lg font-black leading-none mb-1">{title}</h2>
                <span className="text-xs print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
                   PSİKOLOJİK SAĞLAMLIK (YILMAZLIK) KURUMSAL ANALİZİ
                </span>
              </div>
            </div>
            <div className="bg-white/10 px-5 py-2.5 print:px-3 print:py-1.5 rounded-xl text-center print:border print:border-slate-300">
              <span className={`text-3xl print:text-xl font-black block leading-none ${isRedAlarm ? 'text-red-300' : 'text-slate-800'}`}>{data.total}</span>
              <span className="text-[10px] print:text-[8px] block opacity-70 uppercase font-bold mt-1">Katılımcı</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-5 print:gap-3 shrink-0 avoid-break">
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300 ${isRedAlarm ? 'border-red-200 bg-red-50' : 'border-slate-200'}`}>
              <div className="flex items-center mb-1.5">
                 <AlertTriangle className={`h-6 w-6 print:h-4 print:w-4 mr-2 ${isRedAlarm ? 'text-red-500' : 'text-slate-500'}`}/>
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${isRedAlarm ? 'text-red-600' : 'text-slate-600'}`}>Kırılganlık Riski Grubu</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${isRedAlarm ? 'text-red-700' : 'text-slate-700'}`}>
                 {data.redAlarmStudents} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Öğrenci (%{redAlarmPercent})</span>
              </p>
            </div>

            <div className="bg-indigo-50 p-5 print:p-3 rounded-2xl border border-indigo-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Target className="h-6 w-6 print:h-4 print:w-4 mr-2 text-indigo-600"/>
                 <span className="text-sm print:text-[10px] font-black text-indigo-600 uppercase tracking-widest">Baskın Grup Profili</span>
              </div>
              <p className="text-base print:text-[12px] font-black text-indigo-900 mt-1 leading-tight truncate">
                {data.avgScore < 18 ? 'Kırılgan / Riskli' : data.avgScore >= 25 ? 'Dirençli / Yüksek' : 'Dengeli / Gelişime Açık'}
              </p>
            </div>

            <div className="bg-amber-50 p-5 print:p-3 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Activity className="h-6 w-6 print:h-4 print:w-4 mr-2 text-amber-600"/>
                 <span className="text-sm print:text-[10px] font-black text-amber-600 uppercase tracking-widest">Kurum Ortalama Skoru</span>
              </div>
              <p className="text-2xl print:text-lg font-black text-amber-900 mt-1">
                 {data.avgScore} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">/ 30 Puan</span>
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 mt-1 print:mt-0">
            
            {/* KART 1: YATAY - EN ZORLANILAN 5 DURUM */}
            <div className="col-span-2 bg-amber-50 p-4 print:p-3.5 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm print:shadow-none flex flex-col justify-center avoid-break">
               <div className="flex justify-between items-center border-b border-amber-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-amber-900 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <AlertTriangle className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-amber-600"/> Nokta Atışı: Toparlanmakta En Çok Zorlanılan Kriz Alanları
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-amber-700 print:text-slate-500 italic">Zorlanma Oranı</span>
               </div>
               
               <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-x-6 gap-y-2 print:gap-x-4 print:gap-y-1 mt-1">
                 {data.topItems.length > 0 ? data.topItems.map((item, idx) => (
                   <div key={idx} className="flex justify-between items-center bg-white print:bg-amber-50/30 px-3 py-2 print:px-2 print:py-1 rounded-lg border border-amber-100 print:border-amber-200 shadow-sm print:shadow-none">
                     <div className="flex items-center flex-1 overflow-hidden pr-3 print:pr-1">
                        <span className="text-amber-500 mr-2 font-black text-xs print:text-[9px]">{(idx + 1)}.</span> 
                        <span className="text-[11px] print:text-[8.5px] font-bold text-slate-800 leading-tight truncate" title={item.text}>{item.text}</span>
                     </div>
                     <span className="text-xs print:text-[9px] font-black text-amber-600 shrink-0">%{item.percent}</span>
                   </div>
                 )) : (
                   <p className="text-xs text-slate-500 italic col-span-2 text-center">Yeterli veri yok.</p>
                 )}
               </div>
            </div>

            {/* KART 2: YATAY - RİSKLİ SINIFLAR */}
            <div className="col-span-2 bg-slate-50 p-5 print:p-3.5 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 shadow-sm print:shadow-none avoid-break">
               <div className="flex justify-between items-center border-b border-slate-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-slate-800 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <BarChart3 className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-slate-600"/> Sınıfların Yılmazlık Ortalama Dağılımı (En Düşükten Yükseğe)
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-slate-500 italic">Ortalama Skor (Maks 30)</span>
               </div>
               
               <div className="space-y-3 print:space-y-2 mt-2">
                  {data.classStats.slice(0, 4).map((cls, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between items-end mb-1 print:mb-0.5">
                        <span className="text-xs print:text-[9px] font-bold text-slate-700">{cls.name}</span>
                        <span className="text-xs print:text-[9px] font-black text-slate-900">{cls.avgScore} Puan <span className="text-[10px] print:text-[7.5px] text-slate-500 font-medium">({cls.studentCount} Kişi)</span></span>
                      </div>
                      <div className="h-2 print:h-1.5 w-full bg-slate-200 print:bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-200">
                        <div className={`h-full rounded-full ${cls.avgScore < 18 ? 'bg-red-500' : cls.avgScore >= 25 ? 'bg-emerald-500' : 'bg-blue-500'}`} style={{ width: `${(cls.avgScore / 30) * 100}%` }}></div>
                      </div>
                    </div>
                  ))}
               </div>
            </div>

          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
             
             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] ${interventionObj.bg}`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <interventionObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${interventionObj.color}`}/>
                  Kurumsal Müdahale Odağı
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${interventionObj.color}`}>
                      {interventionObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {interventionObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {interventionObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${interventionObj.color}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] ${stakeholderObj.bg}`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <stakeholderObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${stakeholderObj.color}`}/>
                  Paydaş Eylem Planı
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${stakeholderObj.color}`}>
                      {stakeholderObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {stakeholderObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {stakeholderObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${stakeholderObj.color}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

          </div>

        </div>

        <div className="hidden print:block" style={{ pageBreakBefore: 'always' }}></div>

        {/* ========================================================= */}
        {/* SAYFA 2: YAPAY ZEKA RAPORU VE İMZALAR                    */}
        {/* ========================================================= */}
        <div className="flex flex-col mt-4 print:mt-0">
          
          <div className="bg-purple-50 p-6 print:p-0 rounded-3xl print:rounded-none border border-purple-100 print:border-none shadow-sm print:shadow-none flex flex-col pt-2 print:pt-4">
            <div className="flex justify-between items-center mb-4 print:mb-3 border-b border-purple-200 print:border-slate-300 pb-3 print:pb-3 shrink-0">
              <h3 className="font-bold text-purple-900 flex items-center text-base print:hidden uppercase tracking-widest">
                <Sparkles className="h-5 w-5 mr-2 text-purple-600"/> Yapay Zeka Kurumsal Strateji Raporu
              </h3>
              <h3 className="hidden print:flex items-center font-bold text-slate-900 text-sm uppercase tracking-widest w-full">
                <Brain className="h-5 w-5 mr-2"/> Kurumsal Psikolojik Sağlamlık Strateji Planı
              </h3>
              <button onClick={() => onGenerateAI(title, data.topItems)} disabled={aiLoading} className="px-5 py-2.5 bg-purple-600 text-white rounded-xl font-bold text-xs hover:bg-purple-700 transition shadow-sm print:hidden flex items-center">
                {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Brain className="h-4 w-4 mr-2"/>}
                {aiLoading ? "Analiz Ediliyor..." : "Raporu Oluştur"}
              </button>
            </div>
            {aiResult && (
            <div className="bg-white p-6 rounded-xl text-slate-800 border border-purple-100 print:border-0 print:p-0 print:text-black mt-4">
                <EditableAIBox text={aiResult} />
            </div>
        )}
          </div>

          <div className="hidden print:flex justify-between mt-8 pt-6 text-[12px] text-black px-12 border-t border-slate-300 avoid-break print:break-inside-avoid">
              <div className="text-center">
                  <p className="font-bold">Okul Psikolojik Danışmanı</p>
                  <p className="mt-12">İmza</p>
              </div>
              <div className="text-center">
                  <p className="font-bold">Okul Müdürü</p>
                  <p className="mt-12">İmza</p>
              </div>
          </div>
          
        </div>
      </div>
    </>
  );
};